import React, { Component } from "react";

import { checkRememberMe } from "./remember-me";

import {MfaCurrentProvider} from "./mfa-current-provider";

import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import {MESSAGE_IDS} from 'constants/message-ids'

class MfaEnabled extends Component {
    state = { rememberMeChecked: false };

    componentDidMount() {
        const { orgId, userId, onVerify } = this.props;

        if (checkRememberMe({ orgId, userId })) {
            onVerify();
        }

        this.setState({ rememberMeChecked: true });
    }

    displayTitle() {
        const {messages}=this.props;
        const props = { title: messages[MESSAGE_IDS.MFA.TITLE_ENABLED] };

        return <CardHeader {...props} />;
    }

    displayCurrentProvider() {
        const { userId, orgId, onVerify, mfaOption,messages} = this.props;
        const props = { provider: mfaOption, userId, orgId, onVerify, enabled: true,messages };

        return <MfaCurrentProvider {...props}/>
    }

    render() {
        const { rememberMeChecked } = this.state;

        if (!rememberMeChecked) {
            const props = { title: "Checking Authentication" };

            return <CardHeader {...props} />;
        }

        const { classes } = this.props;

        return (
            <React.Fragment>
                {this.displayTitle()}
                <CardContent className={classes.cardContent}>
                    {this.displayCurrentProvider()}
                </CardContent>
            </React.Fragment>
        );
    }
}

export { MfaEnabled };
